import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';

import type { LocationModel } from '@/entities/location';

import { getLocationIcon } from '../leaflet-icons';

interface LocationIconLayerProps {
  locations: LocationModel[];
}

/**
 * Plain location icons behind the markers. Legacy puts them in the shadow pane for
 * exactly that reason — it is the only way to keep them under the pies
 * (`mapping.js:556-562`).
 */
export const LocationIconLayer = React.memo(function LocationIconLayer({ locations }: LocationIconLayerProps) {
  return (
    <>
      {locations.map((location) => (
        <Marker
          key={location.id}
          position={[location.lat, location.lng]}
          icon={getLocationIcon(location.type, location.portType)}
          pane="shadowPane">
          <Tooltip direction="top">{location.name}</Tooltip>
        </Marker>
      ))}
    </>
  );
});
